import { PlanSeq } from '@mobi/api-types'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import {
  isRefundedStatus,
  isSameRaceMulti,
  isTippingTicket,
} from '@core/Areas/AccountActivity/Components/Ticket/helpers'

export function shouldHideLegStatusSilks(ticket: Omit<Ticket, 'ticketSequence'>) {
  const isMulti = !isTippingTicket(ticket) && ticket.legs.length > 1
  const isDoubleOrQuaddie = [PlanSeq.Double, PlanSeq.Quaddie].includes(ticket.planSeq)

  // don't display status silks for SRM if the bet is refunded (including the derived refunded states)
  const isRefundedSameRaceMulti = isSameRaceMulti(ticket) && isRefundedStatus(ticket)

  return (!isMulti && !isDoubleOrQuaddie) || isRefundedSameRaceMulti
}
